import { render, staticRenderFns } from "./DetailsUser.vue?vue&type=template&id=5c388613&scoped=true&lang=html&"
import script from "./DetailsUser.vue?vue&type=script&lang=js&"
export * from "./DetailsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c388613",
  null
  
)

export default component.exports